import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import {
  headerHeight,
  SocialWelfareLeftMenuList,
  stickyHeaderStyle,
  UiThemeBlueColor,
} from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { scrollContainerStyle } from "../components/TableStructure";
import { PopupComponent } from "../components/PopupComponent";

const List = [
  {
    nameOfScheme: "National old age pension scheme (NOAPS)",
    eligibilityCriteria:
      "Age - above 65 years Annual income -less than Rs.4000/- p.a.",
    benefits: "Rs. 100/- per month",
    formIssuingBody: "Bustee Services Cell at KMC Head-Office",
    supportDocumentsRequired: "Age Proof Photo-graph Proof of income",
    formsToBeSubmittedTo:
      "Borough Executive Engineer with recommendation from Local Councilor",
    sanctioningAuthority:
      "MC on recommendation of DG(Bustee) and Borough Chairman",
    processingTimeOfAppForms: "3 Months",
    finalPayout: "As per availability of funds",
    grievanceHandlingProcedure: "Inform DG(Bustee)",
    remarks: "At present fresh applications are not accepted",
  },
  {
    nameOfScheme: "At present fresh applications are not accepted",
    eligibilityCriteria:
      "Death of the only earning member whose annual income is Rs.11000/- or less than Rs. 11000/-",
    benefits: "Family of that person would be given assistance of Rs. 10000/-.",
    formIssuingBody: "Bustee Services Cell at KMC Head-Office (Annex-A)",
    supportDocumentsRequired:
      "Death Certificate Photo-graph Proof of income Proof of only earning member",
    formsToBeSubmittedTo:
      "Borough Executive Engineer with recommendation from Local Councilor",
    sanctioningAuthority:
      "MC on recommendation of DG(Bustee) and Borough Chairman",
    processingTimeOfAppForms: "3 Months",
    finalPayout: "As per availability of funds",
    grievanceHandlingProcedure: "Inform DG(Bustee)",
    remarks: "",
  },

  {
    nameOfScheme: "National Maternity Benefit Scheme (N M B S)",
    eligibilityCriteria:
      "Pregnant mothers of 19 years and above A family income of below Rs. 4000 per annum",
    benefits: "Assistance of Rs.500/- per issue subject to a max of 2 issues",
    formIssuingBody: "Bustee Services Cell at KMC Head-Office (Annex-B)",
    supportDocumentsRequired:
      "Age Proof Photo-graph Proof of income Declaration of no. of children Proof of pregnancy",
    formsToBeSubmittedTo:
      "Borough Executive Engineer with recommendation from Local Councilor",
    sanctioningAuthority:
      "MC on recommendation of DG(Bustee) and Borough Chairman",
    processingTimeOfAppForms: "1 Month",
    finalPayout: "As per availability of funds",
    grievanceHandlingProcedure: "Inform DG(Bustee)",
    remarks: "",
  },

  {
    nameOfScheme: "Anapurna",
    eligibilityCriteria: "65 Years old BPL only",
    benefits: "At free cost - 10 Kg Wheat or 10 Kg Rice per month",
    formIssuingBody: "Bustee Services Cell at KMC Head-Office (Annex-C)",
    supportDocumentsRequired: "Income declaration Photograph",
    formsToBeSubmittedTo:
      "Borough Executive Engineer with recommendation from Local Councilor",
    sanctioningAuthority:
      "MC on recommendation of DG(Bustee) and Borough Chairman",
    processingTimeOfAppForms: "3 Months",
    finalPayout: "",
    grievanceHandlingProcedure: "Inform DG(Bustee)",
    remarks: "",
  },

  {
    nameOfScheme: "Antyodaya Anna Yojana",
    eligibilityCriteria: "BPL ration card Holder",
    benefits:
      "Wheat at Rs.2/-per Kg and Rice at Rs.3/- per Kg subject to a total of 25 Kg per month per family",
    formIssuingBody: "Bustee Services Cell at KMC Head-Office (Annex-C)",
    supportDocumentsRequired: "Income declaration Photograph",
    formsToBeSubmittedTo:
      "Borough Executive Engineer with recommendation from Local Councilor",
    sanctioningAuthority:
      "MC on recommendation of DG(Bustee) and Borough Chairman",
    processingTimeOfAppForms: "3 Months",
    finalPayout: "",
    grievanceHandlingProcedure: "Inform DG(Bustee)",
    remarks: "",
  },
];

const Govt_Sponsored_Schemes = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container"></div>
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {SocialWelfareLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container" style={{ minHeight: `calc(100vh - ${headerHeight+50}px)` }}>
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Govt. Sponsored Schemes :")}
                    </h3>
                  </div>
                  <div className="d-flex justify-content-center w-100">
                    <PopupComponent
                      moduleTitle={"Govt. Sponsered Schemes"}
                      label={
                        <>
                          What are the other different govt. sponsored schemes
                          for poverty alleviation?
                          <br />
                          What is the eligibility criteria and benefits? And how
                          can I apply?
                        </>
                      }
                      minWidth={"95%"}
                    >
                      <div style={scrollContainerStyle}>
                        <table
                          border={0}
                          align="center"
                          cellPadding={2}
                          cellSpacing={2}
                          className="table table-bordered mb-0"
                        >
                          <thead>
                            <tr
                              bgcolor={UiThemeBlueColor}
                              align="center"
                              valign="middle"
                            >
                              <th
                                // width="30%"
                                className="text-white tble-brder-left align-top"
                                style={stickyHeaderStyle}
                              >
                                Sl. No.
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Name of Scheme
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Eligibility Criteria
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Benefits
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Form Issuing body
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Support documents required
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Forms to be submitted to
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Sanctioning Authority
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Processing time of app. Forms
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Final Pay-out
                              </th>
                              <th
                                // width="20%"
                                className="text-white align-top"
                                style={stickyHeaderStyle}
                              >
                                Grievance handling procedure
                              </th>
                              <th
                                // width="50%"
                                className="text-white align-top tble-brder-right"
                                style={stickyHeaderStyle}
                              >
                                Remarks
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {List.map(
                              (
                                {
                                  nameOfScheme,
                                  eligibilityCriteria,
                                  benefits,
                                  formIssuingBody,
                                  supportDocumentsRequired,
                                  formsToBeSubmittedTo,
                                  sanctioningAuthority,
                                  processingTimeOfAppForms,
                                  finalPayout,
                                  grievanceHandlingProcedure,
                                  remarks,
                                },
                                index
                              ) => (
                                <tr key={index}>
                                  <td valign="top">{index + 1}</td>
                                  <td valign="top">{nameOfScheme}</td>
                                  <td valign="top">{eligibilityCriteria}</td>
                                  <td valign="top">{benefits}</td>
                                  <td valign="top">{formIssuingBody}</td>
                                  <td valign="top">
                                    {supportDocumentsRequired}
                                  </td>
                                  <td valign="top">{formsToBeSubmittedTo}</td>
                                  <td valign="top">{sanctioningAuthority}</td>
                                  <td valign="top">
                                    {processingTimeOfAppForms}
                                  </td>
                                  <td valign="top">{finalPayout}</td>
                                  <td valign="top">
                                    {grievanceHandlingProcedure}
                                  </td>
                                  <td valign="top">{remarks}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </PopupComponent>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Govt_Sponsored_Schemes;
